import {z} from 'zod';

import {isDefiniteNewVehicleRejection} from '@dms/api/new-vehicle';

import {catalogueErrorCodes} from './catalogueUi';

/** The BE refusal of a package-only feature that a trim of the year offers as optional. */
export const FEATURE_OPTIONAL_ON_TRIM = 'DMS-NV-CT-0079';
const BATCH_OPERATION_REFUSED = 'DMS-NV-CT-0078';
const OPTIONAL_ON_PACKAGE_ONLY_FEATURE = 'optionalOnPackageOnlyFeature';

const reasonedRefusal = z.object({
  data: z.object({
    errors: z
      .array(z.object({code: z.string().optional(), reason: z.string().optional()}))
      .optional(),
  }),
});

/**
 * A refusal of one entry whose BE message says why: `DMS-NV-CT-0079`, or `DMS-NV-CT-0078` with the
 * reason `optionalOnPackageOnlyFeature`. The message names the feature, the trim and its model year.
 */
export const isCodedEntryRefusal = (error: unknown): boolean =>
  isDefiniteNewVehicleRejection(error) &&
  (catalogueErrorCodes(error).includes(FEATURE_OPTIONAL_ON_TRIM) ||
    (reasonedRefusal.safeParse(error).data?.data.errors ?? []).some(
      ({code, reason}) =>
        code === BATCH_OPERATION_REFUSED && reason === OPTIONAL_ON_PACKAGE_ONLY_FEATURE
    ));
